import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfPriceLevelVendor(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    {
      header: "PRICE LEVEL VENDOR",
      key: "price_level_vendor",
      width: 10,
    },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.price_level_vendor_code ?? "-",
    price_level_vendor: item.price_level_vendor_name ?? "-",
    description: item.description ?? "-",
  }));

  return (
    <PdfTemplate data={dataMap} column={columns} title="Price Level Vendor" />
  );
}
